import { useFormik } from 'formik';
import { initialValues } from './formData';
import { validationSchema } from './formData';
import { SingleDynamicField } from '../../../../../shared/types/assistant';
import { useEffect } from 'react';
import {
    ChatAssistant,
    InitialConfiguration,
} from '../../../../../shared/types/chat-assistant';

interface KnowledgeBaseRulesForm {
    [key: string]: SingleDynamicField[];
}

export const useKnowledgeBaseRules = (chatAssistant: ChatAssistant) => {
    const formikKnowledgeBaseRules = useFormik<KnowledgeBaseRulesForm>({
        initialValues,
        validationSchema,
        onSubmit: console.log,
    });

    useEffect(() => {
        if (chatAssistant) {
            formikKnowledgeBaseRules.setValues({
                knowledgeBaseRules:
                    (
                        chatAssistant?.initialConfiguration as InitialConfiguration
                    )?.knowledgeBaseRules ?? initialValues.knowledgeBaseRules,
            });
        }
    }, [chatAssistant]);

    return { formikKnowledgeBaseRules };
};
